var _line, _line2, _line3, _line4, _line5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardSummaryChartZeroState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 225,
    viewBox: "0 0 465 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 84.3711,
    y1: 17.5,
    x2: 431.371,
    y2: 17.5,
    stroke: "#E9E9E9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 84.3711,
    y1: 45.5,
    x2: 431.371,
    y2: 45.5,
    stroke: "#E9E9E9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 84.3711,
    y1: 73.5,
    x2: 431.371,
    y2: 73.5,
    stroke: "#E9E9E9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 84.3711,
    y1: 101.5,
    x2: 431.371,
    y2: 101.5,
    stroke: "#E9E9E9"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 84.3711,
    y1: 129.5,
    x2: 431.371,
    y2: 129.5,
    stroke: "#E9E9E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.6279,
    y: 25,
    width: 21,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6279,
    y: 49,
    width: 21,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6279,
    y: 73,
    width: 21,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6279,
    y: 97,
    width: 21,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6279,
    y: 121,
    width: 21,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.4961,
    y: 133,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84.4961,
    y: 147,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 144.496,
    y: 133,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 144.496,
    y: 147,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 204.496,
    y: 133,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 204.496,
    y: 147,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 264.496,
    y: 133,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 264.496,
    y: 147,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 324.496,
    y: 133,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 324.496,
    y: 147,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 384.496,
    y: 133,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 384.496,
    y: 147,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#F0F2F5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 177,
    width: 44,
    height: 14,
    rx: 7,
    fill: "#F0F2F5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 177,
    width: 44,
    height: 14,
    rx: 7,
    fill: "#F0F2F5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 240.5,
    y: 177,
    width: 44,
    height: 14,
    rx: 7,
    fill: "#F0F2F5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 300.5,
    y: 177,
    width: 44,
    height: 14,
    rx: 7,
    fill: "#F0F2F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSummaryChartZeroState);
export default __webpack_public_path__ + "static/media/CardSummaryChartZeroState.2cdb9ae3e8bb256b30fb8efd7cadee2b.svg";
export { ForwardRef as ReactComponent };